import { EventProductCard, LoadingProductCard } from '@account/components';
import { useAttendedEventsContext } from '@account/contexts';
import { PaginationReturn } from '@common/types/service';
import { CenteredEmptyState } from '@components/display/emptyStates';
import { Pagination } from '@components/utility/pagination';
import { useAllPublicEventsQuery } from '@event/services';
import { RegistrationEventListItem } from '@event/types';
import { Stack } from '@mui/material';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

const filtersAndOrdering = {
    filters: {
        present: ['yes'],
        /**
         * This endpoint is by default only returning events that are ongoing or upcoming.
         * To also include past events (which is necessary to show attended events), we need to send date_end= as a filter.
         */
        date_end: ['blank'],
    },
    ordering: 'date_start',
};

export const AttendedEventsMobile = () => {
    const [page, setPage] = useState(1);
    const intl = useIntl();
    const { downloadingCertificateKey, handleDownloadCertificate } = useAttendedEventsContext();

    const { data: attendedEventsMobileData, isFetching: isAttendedEventsMobileFetching } = useAllPublicEventsQuery({
        ...filtersAndOrdering,
        page_size: 3,
        page,
    });
    const attendedEventsMobile = attendedEventsMobileData as PaginationReturn<RegistrationEventListItem>;

    // Prefetch adjacent pages
    useAllPublicEventsQuery(
        {
            ...filtersAndOrdering,
            page_size: 3,
            page: page - 1,
        },
        {
            skip: page === 1,
        }
    );

    useAllPublicEventsQuery({
        ...filtersAndOrdering,
        page_size: 3,
        page: page + 1,
    });
    //#endregion

    return (
        <>
            <Stack direction="column" gap="24px" mb="24px">
                {isAttendedEventsMobileFetching ? (
                    Array.from({ length: 3 }).map((_, index) => (
                        <LoadingProductCard key={`skeleton-${index}`} intl={intl} />
                    ))
                ) : attendedEventsMobile.count > 0 ? (
                    attendedEventsMobile?.results.map((event) => (
                        <EventProductCard
                            key={`event-${event.type}-${event.id}`}
                            event={event}
                            onDownloadCertificate={() => handleDownloadCertificate(event)}
                            isCertificatesDownloading={downloadingCertificateKey[`${event.type}-${event.id}`]}
                        />
                    ))
                ) : (
                    <CenteredEmptyState
                        message={
                            <FormattedMessage
                                id="account.events.noAttendedEvents"
                                defaultMessage="You haven't attended any events yet."
                            />
                        }
                    />
                )}
            </Stack>
            {attendedEventsMobile?.count > 0 && (
                <Pagination
                    count={Math.ceil(attendedEventsMobile.count / 3)}
                    onChange={(_e, newPage) => setPage(newPage)}
                />
            )}
        </>
    );
};
